import { createHash } from 'crypto';
export class RequestSignature {
    secret;
    static HEADER_SIGNATURE = 'x-trecs-webhook-signature';
    static HEADER_TIMESTAMP = 'x-trecs-webhook-timestamp';
    static HEADER_PAYLOAD_HASH = 'x-trecs-webhook-payload-hash';
    constructor(secret) {
        this.secret = secret;
    }
    _sign(payload, timestamp) {
        // Prepare data to sign
        const payloadHash = createHash('sha256').update(payload).digest('hex');
        // Create HMAC signature
        const signature = createHash('sha256')
            // -
            .update(payloadHash)
            .update(timestamp)
            .update(this.secret)
            .digest('hex');
        return {
            [RequestSignature.HEADER_PAYLOAD_HASH]: payloadHash,
            [RequestSignature.HEADER_SIGNATURE]: signature,
        };
    }
    sign(payload) {
        const timestamp = Date.now().toString();
        return {
            [RequestSignature.HEADER_TIMESTAMP]: timestamp,
            ...this._sign(payload, timestamp),
        };
    }
    verify(headers, payload) {
        const signature = headers[RequestSignature.HEADER_SIGNATURE];
        const timestamp = headers[RequestSignature.HEADER_TIMESTAMP];
        const payloadHash = headers[RequestSignature.HEADER_PAYLOAD_HASH];
        if (typeof signature !== 'string' || typeof timestamp !== 'string' || typeof payloadHash !== 'string') {
            return false;
        }
        const signed = this._sign(payload, timestamp);
        if (payloadHash !== signed[RequestSignature.HEADER_PAYLOAD_HASH]) {
            console.warn('payloadHash mismatch', payloadHash, signed[RequestSignature.HEADER_PAYLOAD_HASH]);
            return false;
        }
        if (signature !== signed[RequestSignature.HEADER_SIGNATURE]) {
            console.warn('signature mismatch', signature, signed[RequestSignature.HEADER_SIGNATURE]);
            return false;
        }
        return true;
    }
}
//# sourceMappingURL=RequestSignature.js.map